// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"68":"4f60626a","385":"01ea6f48","603":"8f1598e8","618":"f2c43ef4","738":"c5c84499","774":"faac3621","840":"7a431823","850":"55f30f3b"}[chunkId] + ".chunk.js";
};